import { createStyles } from 'antd-style'

export const useStyles = createStyles(({ token }) => ({
  collapse: {
    border: `1px solid ${token.colorSplit}`
  },
  collapseRow: {
    paddingBlock: 24,
    paddingInline: 16
  },
  title: {
    fontSize: '20px !important'
  },
  treatmentTypeTag: {
    border: 0,
    backgroundColor: token.primary.primary2,
    color: token.colorWhite,
    borderRadius: 16,
    padding: '4px 10px 4px 12px'
  },
  text: {
    fontSize: '20px !important',
    fontWeight: '700'
  },
  successIcon: {
    color: token.colorSuccess
  },
  errorIcon: {
    color: token.colorError
  }
}))
